// extracted by mini-css-extract-plugin
export default {"signupMainDiv":"Signup_signupMainDiv__1hnVR","container":"Signup_container__3F2lz","alreadyAccText":"Signup_alreadyAccText__fHOin","siteLogo":"Signup_siteLogo__HgQB-"};